import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { View } from '../sic-lib/types/View';
import { defaultView } from '../sic-lib/utils/defaultView';

// --------------
// STATE

export interface ViewState {
    view: View;
}

const initialState: ViewState = {
    view: defaultView,
};

const viewSlice = createSlice({
    name: 'view',
    initialState,
    reducers: {
        updateView: (state, action: PayloadAction<{ viewData: View }>) => {
            const { viewData } = action.payload;
            state.view = viewData;
        },
    },
});

export const { updateView } = viewSlice.actions;

export default viewSlice.reducer;
